import React, { useContext, useRef } from 'react';

import { FEATURE_FLAGS } from '../../config/featureFlags';
import { DEFAUL_MARKER_ICON } from '../../constants/icons';
import MapyCzContext from '../../context/MapyCzContext';
import { ResultSMapWrapper } from '../SMap/ResultSMapWrapper';
import { RoundSMapWrapper } from '../SMap/RoundSMapWrapper';

const GuessingMap = ({
    currentRoundGuessedPoint,
    isBattle,
    refLayerValue,
    roundGuessed,
    refVectorLayerSMapValue,
    saveCurrentClickedMapPointCoordinates,
}) => {
    const mapyContext = useContext(MapyCzContext);
    const refLayeredMapValue = useRef();

    const clickMapPoint = (e, coords) => {
        // Nové Leaflet API - coords přichází přímo jako { lat, lon }
        if (FEATURE_FLAGS.USE_NEW_MAP_API && coords && coords.lat !== undefined) {
            saveCurrentClickedMapPointCoordinates({
                mapLat: coords.lat,
                mapLon: coords.lon,
            });
            return;
        }

        // Staré SMap API
        // Došlo ke kliknutí, spočítáme kde
        const options = {
            url: DEFAUL_MARKER_ICON,
            anchor: { left: 10, bottom: 1 } /* Ukotvení značky za bod uprostřed dole */,
        };
        // FYI state is not working in event handling
        refLayerValue.current.removeAll();
        const smapCoords = mapyContext.SMap.Coords.fromEvent(e.data.event, refLayeredMapValue.current);
        const marker = new mapyContext.SMap.Marker(
            mapyContext.SMap.Coords.fromWGS84(smapCoords.x, smapCoords.y),
            'Můj odhad',
            options,
        );
        refLayerValue.current.addMarker(marker);
        saveCurrentClickedMapPointCoordinates({
            mapLat: smapCoords.y,
            mapLon: smapCoords.x,
        });
    };

    return (
        <>
            {!roundGuessed ? (
                <RoundSMapWrapper
                    onMapClick={clickMapPoint}
                    refLayeredMapValue={refLayeredMapValue}
                    refLayerValue={refLayerValue}
                    refVectorLayerSMapValue={refVectorLayerSMapValue}
                    isBattle={isBattle}
                    currentRoundGuessedPoint={currentRoundGuessedPoint}
                />
            ) : (
                <ResultSMapWrapper currentRoundGuessedPoint={currentRoundGuessedPoint} isBattle={isBattle} />
            )}
        </>
    );
};

export default GuessingMap;
